<template>
    <div v-if="isLoading" class="container-fluid">
        <span class="fa fa-spinner fa-spin"></span>
    </div>
    <div v-else-if="hasError" class="container mt-4">
        <div class="alert alert-danger text-center">
            <font-awesome-icon icon="circle-xmark" class="text-danger"/>
            Door een interne fout is OMS op dit moment niet beschikbaar. Probeer het a.u.b. over enkele minuten nogmaals.
        </div>
    </div>
    <div v-else-if="!isLoggedIn" class="container mt-4">
        <div class="alert alert-danger text-center">
            Je bent niet ingelogd.
            <span v-if="$store.state.config?.general?.environment !== 'local'">
                Je wordt binnen enkele seconden doorverwezen...
                <font-awesome-icon icon="spinner" spin/>
            </span>
        </div>
    </div>
    <div v-else class="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header">
        <header-vue></header-vue>
        <div class="app-main">
            <div class="app-sidebar sidebar-shadow sidebar-text-light">
                <div class="scrollbar-sidebar ps" style="overflow-y: auto !important;">
                    <div class="app-sidebar__inner">
                        <menu-vue></menu-vue>
                    </div>
                </div>
            </div>
            <div class="app-main__outer">
                <div class="app-main__inner">
                    <router-view :key="$root.routerKey"/>
                    <b-alert variant="warning" :show="!$root.routerKey">
                        Pagina niet gevonden
                    </b-alert>
                </div>
            </div>
        </div>

        <alert-container/>
    </div>
</template>

<script>
import headerVue from "@/components/Header.vue"
import menuVue from "@/components/Menu.vue"
import AlertContainer from "./components/AlertContainer";
import _ from "lodash"
import appVersion from "./data/appVersion"

export default {
    name: 'App',
    components: {headerVue, menuVue, AlertContainer},

    computed: {
        isLoggedIn() {
            return !_.isEmpty(this.$store.state.user)
        },
        appVersion() {
            return appVersion
        },
    },

    data() {
        return {
            isLoading: true,
            hasError: false,
        }
    },

    created() {
        console.log(`
/-------------------------------------------------------\\\n
             OmniStock OMS version: ${appVersion}\n
\\-------------------------------------------------------/
        `)

        /** Preload data **/
        Promise.all([
            this.$store.getters.getUser,
            this.$store.getters.getConfig,
            this.$store.getters.getLocationsForUser,
        ])
            .then(() => {
                this.isLoading = false
            })
            .catch(e => {
                console.error(e)
                if (e.response?.status !== 401) {
                    this.hasError = true
                }
                this.isLoading = false
            })

        setInterval(() => {
            this.$http.get('/api/keepalive')
        }, 300 * 1000)
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.app-main__outer {
    position: relative;
    width: 100%;
}

@media screen and (min-width: 990px) {
    .fixed-header .app-main { 
        padding-top: 60px;
    }
}

.container-fluid {
    min-height: 100vh;
    background-color: rgba(229, 231, 235);
}

.text-strikethrough {
    text-decoration: line-through;
}
</style>
